import script from "./WikiLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./WikiLayout.vue?vue&type=script&setup=true&lang=js"

import "./WikiLayout.vue?vue&type=style&index=0&id=6b101f18&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b101f18"]])

export default __exports__